"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_1 = require("@cian/config/browser");
var browser_2 = require("@cian/logger/browser");
var shared_1 = require("@cian/peperrors/shared");
var getBaseServiceUri = function (microserviceName, projectName) {
    var baseServiceUri = browser_1.getConfig().get(microserviceName + ".browserUrl");
    if (baseServiceUri) {
        return baseServiceUri;
    }
    var mcsInfo = browser_1.getConfig().getStrict(microserviceName);
    baseServiceUri = mcsInfo['browserUrl'];
    if (!baseServiceUri) {
        browser_2.getLogger().error("HttpAPI error, browserUrl for " + microserviceName + " is not defined", { projectName: projectName });
        throw new shared_1.NotFoundError({
            message: "HttpAPI error, browserUrl for " + microserviceName + " is not defined",
            domain: 'HttpApi#fetch()',
        });
    }
    return baseServiceUri;
};
exports.getBaseServiceUri = getBaseServiceUri;
//# sourceMappingURL=baseServiceUri.js.map